
(() => {
  const MIN_DELAY = 3000;
  const MAX_DELAY = 5000;
  const MAX_VISIBLE_RATIO = 0.35; // require at least 35% of card visible
  const PAUSE_ON_HOVER = true;
  const PAUSE_WHEN_HIDDEN = true;

  const visibleCards = new Set();
  let timer = null;
  let hoveredCard = null;

  function randomDelay() {
    return Math.floor(Math.random() * (MAX_DELAY - MIN_DELAY + 1)) + MIN_DELAY;
  }

  function getCards() {
    return Array.from(document.querySelectorAll('.product-grid__item'));
  }

  function getSlideshow(card) {
    return card.querySelector('slideshow-component');
  }

  function getNextButton(card) {
    return card.querySelector('button[aria-label="Next slide"]');
  }

  function getPrevButton(card) {
    return card.querySelector('button[aria-label="Previous slide"]');
  }

  function getSlides(card) {
    return card.querySelectorAll('slideshow-slide');
  }

  function getCurrentSlideIndex(card) {
    const slides = Array.from(getSlides(card));
    if (!slides.length) return 0;

    const activeIndex = slides.findIndex(slide => slide.getAttribute('aria-hidden') === 'false');
    return activeIndex >= 0 ? activeIndex : 0;
  }

  function canAnimate(card) {
    if (!card || !visibleCards.has(card)) return false;
    if (PAUSE_ON_HOVER && hoveredCard === card) return false;
    if (PAUSE_WHEN_HIDDEN && document.hidden) return false;

    const slideshow = getSlideshow(card);
    const nextButton = getNextButton(card);
    const slides = getSlides(card);

    if (!slideshow || !nextButton || slides.length <= 1) return false;

    return true;
  }

  function animateRandomCard() {
    const candidates = getCards().filter(canAnimate);

    if (!candidates.length) {
      scheduleNext();
      return;
    }

    const card = candidates[Math.floor(Math.random() * candidates.length)];
    const nextButton = getNextButton(card);
    const prevButton = getPrevButton(card);
    const slides = getSlides(card);
    const currentIndex = getCurrentSlideIndex(card);
    const lastIndex = slides.length - 1;

    // Mostly move forward; occasionally reverse for a more natural feel.
    let direction = 'next';
    if (Math.random() < 0.18 && prevButton) {
      direction = 'prev';
    }

    // If we’re at the end and there is no true looping behavior, prefer going back.
    if (currentIndex >= lastIndex && prevButton) {
      direction = 'prev';
    }

    // If we’re at the start, prefer next.
    if (currentIndex <= 0 && nextButton) {
      direction = 'next';
    }

    const targetButton = direction === 'prev' ? prevButton : nextButton;
    if (targetButton) {
      targetButton.click();
    }

    scheduleNext();
  }

  function scheduleNext() {
    clearTimeout(timer);
    timer = setTimeout(animateRandomCard, randomDelay());
  }

  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting && entry.intersectionRatio >= MAX_VISIBLE_RATIO) {
        visibleCards.add(entry.target);
      } else {
        visibleCards.delete(entry.target);
      }
    }
  }, {
    threshold: [0, 0.35, 0.5, 0.75]
  });

  function initCard(card) {
    observer.observe(card);

    if (PAUSE_ON_HOVER) {
      card.addEventListener('mouseenter', () => {
        hoveredCard = card;
      });

      card.addEventListener('mouseleave', () => {
        if (hoveredCard === card) hoveredCard = null;
      });

      card.addEventListener('touchstart', () => {
        hoveredCard = card;
      }, { passive: true });

      card.addEventListener('touchend', () => {
        if (hoveredCard === card) hoveredCard = null;
      }, { passive: true });
    }
  }

  function init() {
    getCards().forEach(initCard);
    scheduleNext();
  }

  // Re-scan if products are added dynamically (filters, infinite scroll, etc.)
  const domObserver = new MutationObserver(() => {
    getCards().forEach(card => {
      if (!card.__luxuryAutoSlideInit) {
        card.__luxuryAutoSlideInit = true;
        initCard(card);
      }
    });
  });

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) scheduleNext();
  });

  document.addEventListener('DOMContentLoaded', () => {
    getCards().forEach(card => {
      card.__luxuryAutoSlideInit = true;
    });

    init();

    const grid = document.querySelector('.product-grid');
    if (grid) {
      domObserver.observe(grid, { childList: true, subtree: true });
    }
  });
})();
